module.exports = __webpack_public_path__ + "img/saracens-DE.6d812b2a.png";